import i18n from "../i18n";

// Languages that use comma as decimal separator
const COMMA_LANGUAGES = [
  'de', 'fr', 'es', 'it', 'nl', 'pt', 'ru', 'tr', 'pl', 'cs', 'sk', 
  'hu', 'ro', 'bg', 'hr', 'sl', 'et', 'lv', 'lt', 'da', 'no', 'sv',
  'fi', 'is', 'mt', 'el', 'mk', 'sr', 'bs', 'sq', 'ca', 'eu'
];

// Get decimal separator for current language
export const getDecimalSeparator = () => {
  return COMMA_LANGUAGES.includes(i18n.language) ? ',' : '.';
};

// Convert display value to internal value (always uses dot)
export const normalizeInput = (value) => {
  if (!value) return value;
  return getDecimalSeparator() === ',' ? value.replace(',', '.') : value;
};

// Convert internal value to display value (uses language separator)
export const formatDisplay = (value) => {
  if (!value && value !== 0) return '';
  const stringValue = String(value);
  return getDecimalSeparator() === ',' ? stringValue.replace('.', ',') : stringValue;
};

// Get validation pattern for current language
export const getValidationPattern = () => {
  return getDecimalSeparator() === ',' ? /^[0-9]*,?[0-9]*$/ : /^[0-9]*\.?[0-9]*$/;
};

// Convert string to number for calculations
export const parseNumber = (value) => {
  if (!value) return 0;
  return parseFloat(normalizeInput(value)) || 0;
};

// Get localized placeholder
export const getPlaceholder = (baseValue) => {
  return baseValue.replace('.', getDecimalSeparator());
};

// Default export object
const DecimalUtils = {
  getDecimalSeparator,
  normalizeInput,
  formatDisplay,
  getValidationPattern,
  parseNumber,
  getPlaceholder
};

export default DecimalUtils;